import { useLocation } from "react-router-dom";
import { TopNav } from "@/components/layout/TopNav";
import { Sidebar } from "@/components/layout/Sidebar";
import { Footer } from "@/components/layout/Footer";

/**
 * Explore-only shell. Presentation Mode uses its own dedicated route and does
 * not pass through this component, so there is no need to branch on mode here.
 */
export const AppShell = ({ children }) => {
  const location = useLocation();
  return (
    <div className="flex min-h-screen flex-col bg-background" data-testid="app-shell">
      <TopNav />
      <div className="flex flex-1">
        <Sidebar />
        <main
          key={location.pathname}
          className="flex-1 animate-fade-in"
          data-testid="main-content"
        >
          {children}
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default AppShell;
